import appConfig from 'app-config';
import { getBrand } from 'flow/brands/brands';

import { List } from 'immutable';
import Spokes from 'resources/headsets/spokes';
import epossdk from 'resources/headsets/epos/epossdk.v1';

import { electronActions } from 'flow/utils/electron-utils';
import { addHeadsetLogEntry } from 'flow/utils/browser-utils';

class HeadsetPoller {
    poll() {
        return Promise.resolve();
    }
}
class Jabra4Poller extends HeadsetPoller {
    async poll() {
        return await electronActions.initJabra();
    }
}

class PlantronicsPoller extends HeadsetPoller {
    poll() {
        return new Promise((resolve) => {
            Spokes.Device.deviceInfo((result) => {
                if (!result.isError && result.Result !== null) {
                    resolve(result.Result);
                } else {
                    resolve();
                }
            });
        });
    }
}

class EPOSPoller extends HeadsetPoller {
    poll() {
        return new Promise((resolve) => {
            const logger = (log) => addHeadsetLogEntry('[EPOS] ' + log);
            const brandName = getBrand().brandNameUIFriendly;
            const sdk = new epossdk(
                brandName,
                brandName,
                appConfig.version,
                -1,
                logger,
            );
            const deviceInfo = {
                sdk: sdk,
                ManufacturerName: 'EPOS',
            };

            const timeoutId = setTimeout(() => {
                sdk.removeAllListeners();
                sdk.SendTerminateEvent();
                resolve();
            }, 5000);
            sdk.on('LoginStatusChanged', (status) => {
                if (status === 'EstablishConnection') {
                    sdk.once('HeadsetConnected', () => {
                        clearTimeout(timeoutId);
                        sdk.removeAllListeners();
                        resolve(deviceInfo);
                    });
                    sdk.SendLoginEvent();
                }
            });
        });
    }
}

class YealinkPoller extends HeadsetPoller {
    async poll() {
        return new Promise((resolve) => {
            electronActions.initYealink().then((deviceId) => {
                if (deviceId) {
                    resolve({
                        ManufacturerName: 'Yealink',
                        deviceId,
                    });
                } else {
                    resolve();
                }
            });
        });
    }
}

const jabra4Poller = new Jabra4Poller();
const plantronicsPoller = new PlantronicsPoller();
const eposPoller = new EPOSPoller();
const yealinkPoller = new YealinkPoller();

export const getHeadsetPollers = () => {
    return List([jabra4Poller, plantronicsPoller, eposPoller, yealinkPoller]);
};
